define([
    'base/utils/iamHttpService',
    'base/utils/utility',
    'base/widgets/graphicVerifyWindow/window',
    'base/utils/preVerifycodeUtil',
], function (iamHttpService, util, GrahicVerifyWindow, perVerifycodeUtil) {
    'use strict';

    var me, i18n, iamUtils, step;

    function FPhoneController($scope, $compile, _i18n, _iamUtils, _step, securityPolicy) {
        i18n = _i18n;
        iamUtils = _iamUtils;
        step = _step;
        me = this;
        step.render($scope, $compile);

        function send2CloudBISafe(){
            try{
                send2CloudBI.apply(null,arguments);
                    
            }catch(e){
            }
        }

        document.title = i18n('titles.fphone');
            
        $scope.redirect2Login = function () {
            send2CloudBISafe('button', 'click' , 'fPhone_'+ getQueryString('UserType') + '_redirect2Login', '');
            iamUtils.redirect2Login();
        };

        $scope.i18n = i18n;
        $scope.model = {
            currentLanguage: window.language,
            width: '310px',
            verifyCodeWidth: '135px',
            codeSelectWidth:'135px',
            phoneInputWidth: '210px',
            height: iamUtils.layout.inputFieldHeight,
            optionWidth:'135px',
            inputFieldHeight: iamUtils.layout.inputFieldHeight,
            scrollHeight: iamUtils.layout.scrollHeight,
            homePageURL: iamUtils.CONFIG.homepageUrl,
            tipPosition:'top',
            type: 'password',
            emailRegExp: /^((([A-Za-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([A-Za-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([A-Za-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([A-Za-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([A-Za-z]|\d|-|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([A-Za-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([A-Za-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([A-Za-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([A-Za-z]|\d|-|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([A-Za-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/,
            emailVCodeBtnTxt: i18n('fphone.getVerifyCodeByEmail'),
            smsVCodeBtnTxt: i18n('fphone.getVerifyCodeBySms'),
            codeJson:'',
            codeArray:[],
            defaultCode: '',
            phoneLenObj: '',
            select: function () {
                var value =  $('#' + $scope.model.newPhoneNumId).widget().getValue();
                var countryCode = iamUtils.getCodeValue($scope.model.codeJson, $('#codeSelectId').widget().getValue());
                $scope.model.phoneLen = iamUtils.getPubPhoneLen($scope.model.codeJson, $scope.model.phoneLenObj);
                $scope.model.phoneValidator = iamUtils.validator.phone($scope.model.phoneLen);
                $scope.$apply();
                iamUtils.unifyValid.FormValid($('#' + $scope.model.newPhoneNumId));
                var errorInfo = validatePhone(value, $scope.model.phoneLen);
                if(errorInfo ===''){
                    me.isKeyExisted($scope, iamHttpService, 'mobile',countryCode, value, i18n('fphone.phoneRepeat'),  $scope.model.newPhoneNumId, '#phoneError');
                }else{
                    $('#phoneError').empty();
                }
            },
            matchMethod: function(keyword, op) {
                keyword = keyword.trim();
                if((op.toLowerCase().indexOf(keyword.toLowerCase()) >= 0) || (keyword == '00' + op.substring(op.indexOf('+') + 1, op.indexOf(')')))){
                    return true;
                }
            },
            enterpriseId: 'enterpriseId',
            enterpriseNamePH: i18n('fpwd.enterpriseNamePH'),
            codeSelectId: 'codeSelectId',
            newPhoneNumId: 'newPhoneNumId',
            newPhoneNumPH: i18n('fphone.newPhoneNumPH'),
            newPhoneNum: '',

            registerEmail: '',
            registerEmailId: 'registerEmailId',
            registerEmailPH: i18n('fphone.registerEmailPH'),

            passwordId: 'passwordId',
            passwordPH: i18n('fphone.'),

            emailVerifyCodeId: 'emailVerifyCodeId',
            emailVerifyCodePH: i18n('fphone.emailVerifyCodePH'),

            smsVerifyCodeId: 'smsVerifyCodeId',
            smsVerifyCodePH: i18n('fphone.smsVerifyCodePH'),

            countToHomepage: iamUtils.i18nFormat(i18n('countToHomepage'), 10),

            sendEmailVCodeFailed: false,
            sendSmsVCodeFailed: false,

            emailCodeMsg: '',
            smsCodeMsg: '',
            lastEmailAddress: '',
            newPhoneNumFocused: false,
            disable: false,
                
            selectChange : function (event , value) {
                send2CloudBISafe('input', 'change' , 'fPhone_'+ getQueryString('UserType') +'_accountPhone_CountryCode' , value);
            },

            textBlur: function (id) {
                    
                var value = iamUtils.getTrimValue(id);

                send2CloudBISafe('input', 'change' , 'fPhone_'+ getQueryString('UserType') + '_' +id, value);
                    
                if(id === $scope.model.enterpriseId)
                {
                    $scope.model.enterpriseName = value;
                }else if (id === $scope.model.registerEmailId){
                    $scope.model.registerEmail = value;
                }else if (id === $scope.model.emailVerifyCodeId){
                    $scope.model.emailVerifyCode = value;
                }else if (id === $scope.model.smsVerifyCodeId){
                    $scope.model.smsVerifyCode = value;
                }

                $scope.$evalAsync();
            },
            onPhoneBlur: function(){
                var value = iamUtils.getTrimValue($scope.model.newPhoneNumId);
                    
                send2CloudBISafe('input', 'change' , 'fPhone_'+ getQueryString('UserType') + '_phone', value);
                    
                $scope.model.newPhoneNum = value;
                $scope.$evalAsync();

                var countryCode = iamUtils.getCodeValue($scope.model.codeJson, $('#codeSelectId').widget().getValue());
                $scope.model.phoneLen = iamUtils.getPhoneRegex(countryCode, $scope.model.phoneLenObj);
                $scope.model.phoneLen = $scope.model.phoneLen ? $scope.model.phoneLen: 32;
                var errorInfo = validatePhone(value, $scope.model.phoneLen);
                if (errorInfo === '')
                {
                    me.isKeyExisted($scope, iamHttpService, 'mobile',countryCode, value, i18n('fphone.phoneRepeat'),  $scope.model.newPhoneNumId, '#phoneError');
                }
            },
            onEmailChange: function(event, value){
                limitLength($scope.model.registerEmailId, value, 255);
            },
            onPhoneChange: function(event, value){
                $('#phoneError').empty();
                limitLength($scope.model.newPhoneNumId, value, 128);
            },
            onEmailVCodeChange: function(event, value){
                limitLength($scope.model.emailVerifyCodeId, value, 120);
            },
            onSmsVCodeChange: function(event, value){
                limitLength($scope.model.smsVerifyCodeId, value, 120);
            },
            checkCodeId:'checkCodeId',
            checkCodeValidator:[iamUtils.validator.childValidator.limitLength(4)],
            checkCode:'',
            checkCodeWidth:190,
            checkCodePH:i18n('fpwd.verifyCodePH'),
            checkCodeTip:i18n('getVerifyCode'),
            checkCodeMaxLength:4,
            verifyCodeImg:'',
        };

        $(document).keydown(function (event) {
            if(event.keyCode === 13){
                var id = $(document.activeElement).attr('id');
                if(id === 'emailMsgBtn'){
                    $scope.model.emailVerifyCodeBtnClick();
                }
                else if (id === 'smsMsgBtn'){
                    $scope.model.smsVerifyCodeBtnClick();
                }
                $scope.$evalAsync();
            }
        });
        initLoginUrl();
        iamUtils.getCountryCode($scope);

        $scope.model.preValidVerifyCode = function(event, value)
        {
            var img = $('#validresultImg');
            perVerifycodeUtil.preValidVerifyCode(img, value, '4', preValidCallback, iamHttpService);
        }

        $scope.model.preValidVerifyCodeBlur= function (event ,value){
            //send2CloudBISafe("input", "change" , "login_" + ($scope.model.isCompany ? 'company' : 'personal') +"_VerifyCodeImg", $scope.model.checkCode);
        }

        $scope.model.getVerifyCodeImg = function(){
            //send2CloudBISafe("button", "click" , "login_" + ($scope.model.isCompany ? 'company' : 'personal')+"_getVerifyCodeImg", '');
            var verifyCodeImg = $('#inputVerifyCodeImg')[0];
            if(verifyCodeImg)
            {
                verifyCodeImg.src = '/authui/verifycode?index=4&alt='+Math.random();
            }
            $scope.model.checkCode = '';
            $('#validresultImg').hide();
        };

        $scope.model.getVerifyCodeImg();

        function preValidCallback(success)
        {
            if(success == false) {
                $scope.model.checkCode = '';
                $scope.$apply();
                var verifyCodeImg = $('#inputVerifyCodeImg')[0];
                if(verifyCodeImg)
                {
                    verifyCodeImg.src = '/authui/verifycode?index=4&alt='+Math.random();
                }
            }
        }

        $scope.model.emailValidator = iamUtils.validator.email();
        $scope.model.countryCodeValidator = iamUtils.validator.countryCode($scope.model.codeArray);
        $scope.model.msgCodeValidator = iamUtils.validator.msgCode();
        $scope.model.smsMsgCodeValidator = iamUtils.validator.smsMsgCode();
        if(iamUtils.getPhoneRegex($scope.model.defaultCode, $scope.model.phoneLenObj)){
            $scope.model.phoneLen = iamUtils.getPhoneRegex($scope.model.defaultCode, $scope.model.phoneLenObj);
        }
        $scope.model.phoneLen = $scope.model.phoneLen ? $scope.model.phoneLen: 32;
        $scope.model.phoneValidator = iamUtils.validator.phone($scope.model.phoneLen);
        var commonValidator = iamUtils.validator.commonValidInput();
        commonValidator.push(iamUtils.validator.required()[0]);
        $scope.model.commonValidator = commonValidator;

        $scope.model.enterpriseValidator = iamUtils.validator.commonValidInput();
        var enterpriseValidator = function (){
            var validators = [
                iamUtils.validator.childValidator.limitLength(128),
                iamUtils.validator.notBlank(false),
                iamUtils.validator.minLen(1)[0],
                iamUtils.validator.maxLen(128, i18n('validAccountName'))[0]
            ];

            return validators;
        }();
        $scope.model.enterpriseFocus = function () {
            if($scope.model.enterpriseValidator != enterpriseValidator)
            {
                $scope.model.enterpriseValidator = enterpriseValidator;
            }
        };

        $scope.model.emailValidator = checkEmail($scope);
        function checkEmail($scope) {
            var emailCheck = {
                validFn: function () {
                    var value = this.val();
                    var emailPattern = $scope.model.emailRegExp;
                    return emailPattern.test(value);
                },
                errorDetail: i18n('validEmail')
            };

            var validators = [
                iamUtils.validator.childValidator.limitLength(255),
                iamUtils.validator.notBlank(true),
                iamUtils.validator.maxLen(255, i18n('validEmail'))[0],//����??��?�䨮3��?��128
                emailCheck
            ]
            return validators;
        }

        $scope.model.step1KeyPress=function(event){
            iamUtils.enterEvent(event, $scope.nextStep1);
        }
        $scope.model.step2KeyPress=function(event){
            iamUtils.enterEvent(event, $scope.nextStep2);
        }

        $scope.nextStep1 = function () {
            send2CloudBISafe('button', 'click' , 'fPhone_'+ getQueryString('UserType') +'_nextStep1' , '');
                
            var $step1 = $('#step1');
            if (!iamUtils.unifyValid.FormValid($step1)) {
                iamUtils.unifyValid.focusFirst($step1);
                return;
            }
            if($scope.model.registerEmail !== $scope.model.lastEmailAddress){
                $scope.model.sendEmailVCodeFailed = false;
                $scope.model.sendSmsVCodeFailed = false;
            }
            checkUserExist($scope);
        };

        function checkUserExist($scope) {
            var domainName = $('#' + $scope.model.enterpriseId).widget().getValue();
            var accountName = $('#' + $scope.model.registerEmailId).widget().getValue();
            var userType = iamUtils.getUrlParams().UserType;

            var checkCode = $scope.model.checkCode;
            	checkCode = $scope.model.checkCode;
            $scope.model.checkCode = '';

            if (checkCode.length < 4){
                	$scope.model.getVerifyCodeImg();
                	iamUtils.MESSAGE.ERROR(i18n('fpwd.EnterCorrectEnterpriseVerificationCode'), '', 'fphonePopupMsg');
                	return;
            }
                
            iamHttpService.post({
                url: '/authui/userFindPwd/exists',
                params: {
                    type: 'email',
                    userType: userType,
                    value: accountName,
                    domainName: domainName,
                    verifyCode: checkCode,
                    scene: 'fphone'
                }
            }).then(function (data) {
                if (data === 'checkVerifyCode4Forbidden') {
                    iamUtils.MESSAGE.ERROR(i18n('operationTooFrequent'), '', 'fphonePopupMsg');
                    return;
                }
                data = typeof data === 'object' ? data : $.parseJSON(data);
                if (data.count != 1) {
                    if(domainName === ''){
                        iamUtils.MESSAGE.ERROR(i18n('fpwd.EnterCorrectEmail'), '', 'fphonePopupMsg');
                    }else{
                        iamUtils.MESSAGE.ERROR(i18n('fpwd.EnterCorrectEnterpriseAccountAndEmail'), '', 'fphonePopupMsg');
                    }
                    return;
                }
                goToStep(2);

                $('#step1').hide();
                $('#step2').show();
            }), function (data) {
                iamUtils.MESSAGE.ERROR(i18n('systemException'), '', 'fphonePopupMsg');
            };
        }

        $scope.onCancelBtnClick=function(){
            send2CloudBISafe('button', 'click' , 'fPhone_'+ getQueryString('UserType') + '_cancelHandlerStep1', '');
                
            window.location.href = $scope.model.loginUrl;
        };

        $scope.model.emailVerifyCodeBtnClick = function() {
                
            send2CloudBISafe('button', 'click' , 'fPhone_'+ getQueryString('UserType') +'_emailVerifyCode' , '');
                
            if($('#emailMsgBtn').hasClass('msgBtnDisabled'))
            {
                return;
            }

            $scope.model.sendEmailVCodeFailed = false;
            sendEmailVCode($scope);
            emailMsgBtnHandler($scope);
        };

        function sendEmailVCode($scope) {
            var userType = getQueryString('UserType');
            if (userType === 'p') {
                var params = {
                    email: $('#' + $scope.model.registerEmailId).widget().getValue()
                }
            } else {
                var params = {
                    domain: encodeURIComponent($('#' + $scope.model.enterpriseId).widget().getValue()),
                    email: $('#' + $scope.model.registerEmailId).widget().getValue()
                }
            }
            $('#emailCodeMsg').hide();
            iamHttpService.post({
                url: '/rest/authui/fphone/emailVerifyCode',
                params: params
            }).then(function (data) {
                if (data.retcode == 200) {
                    if (data.remainderCount >= 0)
                    {
                        $scope.model.emailCodeMsg = data.remainderCount==0? i18n('verifyCode.cantAcquire'):iamUtils.i18nFormat(i18n('verifyCode.remainderCount'), data.remainderCount);
                        $scope.$apply();
                        $('#emailCodeMsg').show();
                    }
                }
                else if(data.retcode == 412) {
                    var lockedMsg = i18n('verifyCode.locked');
                    if (data.lockDuration && data.lockDuration !== -1) {
                        lockedMsg = iamUtils.i18nFormat(i18n('verifyCode.locked.custom'), data.lockDuration);
                    }
                    iamUtils.MESSAGE.ERROR(lockedMsg, '', 'fphonePopupMsg');
                    $scope.model.sendEmailVCodeFailed = true;
                }
                else if(data.retcode == 411) {
                    iamUtils.MESSAGE.ERROR(i18n('verifyCode.intervalError'), '', 'fphonePopupMsg');
                    $scope.model.sendEmailVCodeFailed = true;
                }
                else {
                    iamUtils.MESSAGE.ERROR(i18n('verifyCode.sendFailed'), '', 'fphonePopupMsg');
                    $scope.model.sendEmailVCodeFailed = true;
                }
            }, function () {
                iamUtils.MESSAGE.ERROR(i18n('verifyCode.sendFailed'), '', 'fphonePopupMsg');
                $scope.model.sendEmailVCodeFailed = true;
            });
        }


        function emailMsgBtnHandler($scope) {
            var timeInterval = 60;
            var counter = 0;
            $('#emailMsgBtn').addClass('msgBtnDisabled');
            function timer() {
                if (counter < timeInterval) {
                    if ($scope.model.sendEmailVCodeFailed) {
                        $('#emailMsgBtn').removeClass('msgBtnDisabled');
                        $scope.model.emailVCodeBtnTxt =  i18n('fphone.getVerifyCodeByEmail');
                        $scope.$apply();
                        $scope.model.sendEmailVCodeFailed = false;
                        return;
                    }

                    counter++;
                    $scope.model.emailVCodeBtnTxt = iamUtils.i18nFormat(i18n('msgCodeTxtWait'), timeInterval - counter);
                    if (counter != 0) {
                        $scope.$apply();
                    }

                    setTimeout(timer, 1000);
                }
                else {
                    $('#emailMsgBtn').removeClass('msgBtnDisabled');
                    $scope.model.emailVCodeBtnTxt =  i18n('fphone.getVerifyCodeByEmail');
                    $scope.$apply();
                }
            }
            setTimeout(timer, 0);
        };

        $scope.model.smsVerifyCodeBtnClick = function() {

            send2CloudBISafe('button', 'click' , 'fPhone_'+ getQueryString('UserType') +'_smsVerifyCode' , '');
                
            if(validatePhone($('#' + $scope.model.newPhoneNumId).widget().getValue()) !== '')
            {
                $('#' + $scope.model.newPhoneNumId).widget().option('focused', true);
                return;
            }
            $scope.dft.done(function(){
                sendSmsVerifyCode();
            }).fail(function() {
                $('#' + $scope.model.newPhoneNumId).widget().option('focused', true);
            });
        };

        function sendSmsVerifyCode()
        {
            if($('#smsMsgBtn').hasClass('msgBtnDisabled'))
            {
                return;
            }

            iamHttpService.get({
                url: '/rest/authui/verifycode/needverify',
                params: {
                    scene:  'findPhone'
                }
            }).then(function (data) {
                if(data.needVerify)
                {
                    var winOptions = {
                        title: i18n('GraphicsVerifyCode'),
                    };

                    var win = new GrahicVerifyWindow(i18n, winOptions, okHandler, 5);
                    win.show();
                }
                else
                {
                    smsMsgBtnHandler($scope);
                    setTimeout(function () {
                        sendMsg($scope,null);
                    }, 200);
                }
            }, function () {
                $('#msgBtn').removeClass('msgBtnDisabled');
                iamUtils.MESSAGE.ERROR(i18n('systemException'), '', 'popupMsg');
            });
        }

        function okHandler(verifyCode) {
            $scope.model.sendSmsVCodeFailed = false;
            smsMsgBtnHandler($scope);
            setTimeout(sendMsg($scope, verifyCode), 200);
        }

        function sendMsg($scope, verifyCode){
            $('#smsCodeMsg').hide();
            var countryCode = iamUtils.getCodeValue($scope.model.codeJson, $('#codeSelectId').widget().getValue());
            if(!countryCode){
                $scope.model.sendSmsVCodeFailed = true;
                // js控制显示国家码错误信息
                $('#' + $scope.model.codeSelectId + ' .tiny-combobox-container ').addClass('valid_error_input');
                setTimeout(function () {
                    $('div#codeSelectId div.tiny-combobox-container input').focus().focus();   
                }, 500);
                return ;
            }
            iamHttpService.post({
                url: '/rest/authui/fphone/smsVerifyCode',
                params: {
                    countryCode: countryCode,
                    phone: $('#' + $scope.model.newPhoneNumId).widget().getValue(),
                    graphicsVerifyCode: verifyCode
                }
            }).then(function (data) {
                if (data.retcode == 200) {
                    if (data.remainderCount >= 0)
                    {
                        $scope.model.smsCodeMsg = data.remainderCount==0? i18n('verifyCode.cantAcquire'):iamUtils.i18nFormat(i18n('verifyCode.remainderCount'), data.remainderCount);
                        $scope.$apply();
                        $('#smsCodeMsg').show();
                    }
                }
                else if(data.retcode == 412) {
                    var lockedMsg = i18n('verifyCode.locked');
                    if (data.lockDuration && data.lockDuration !== -1) {
                        lockedMsg = iamUtils.i18nFormat(i18n('verifyCode.locked.custom'), data.lockDuration);
                    }
                    iamUtils.MESSAGE.ERROR(lockedMsg, '', 'fphonePopupMsg');
                    $scope.model.sendSmsVCodeFailed = true;
                }
                else if(data.retcode == 404) {
                    iamUtils.MESSAGE.ERROR(i18n('GrapVerifyCodeFailed'), '', 'fphonePopupMsg');
                    $scope.model.sendSmsVCodeFailed = true;
                }
                else if(data.retcode == 411) {
                    iamUtils.MESSAGE.ERROR(i18n('verifyCode.intervalError'), '', 'fphonePopupMsg');
                    $scope.model.sendSmsVCodeFailed = true;
                }
                else {
                    iamUtils.MESSAGE.ERROR(i18n('verifyCode.sendFailed'), '', 'fphonePopupMsg');
                    $scope.model.sendSmsVCodeFailed = true;
                }
            }, function () {
                iamUtils.MESSAGE.ERROR(i18n('verifyCode.sendFailed'), '', 'fphonePopupMsg');
                $scope.model.sendSmsVCodeFailed = true;
            });
        }

        function smsMsgBtnHandler($scope) {
            var timeInterval = 60;
            var counter = 0;
            $('#smsMsgBtn').addClass('msgBtnDisabled');
            function timer() {
                if (counter < timeInterval) {
                    if ($scope.model.sendSmsVCodeFailed) {
                        $('#smsMsgBtn').removeClass('msgBtnDisabled');
                        $scope.model.smsVCodeBtnTxt =  i18n('fphone.getVerifyCodeBySms');
                        $scope.$apply();
                        $scope.model.sendSmsVCodeFailed = false;
                        return;
                    }

                    counter++;
                    $scope.model.smsVCodeBtnTxt = iamUtils.i18nFormat(i18n('msgCodeTxtWait'), timeInterval - counter);
                    if (counter != 0) {
                        $scope.$apply();
                    }

                    setTimeout(timer, 1000);
                }
                else {
                    $('#smsMsgBtn').removeClass('msgBtnDisabled');
                    $scope.model.smsVCodeBtnTxt =  i18n('fphone.getVerifyCodeBySms');
                    $scope.$apply();
                }
            }
            setTimeout(timer, 0);
        };
            
        function initLoginUrl(){
            var service = util.getUrlParams().service;
            var url = '/authui/login.action?locale=' + window.language;
            $scope.model.loginUrl = (service !== undefined)? url + '&service=' + service : url;
        }

        $scope.nextStep2 = function () {
            send2CloudBISafe('button', 'click' , 'fPhone_'+ getQueryString('UserType') +'_nextStep2' , '');
                
            var $nextBtn = $('#nextBtn');
            if ($nextBtn.hasClass('submitBtnDisable')) {
                return;
            }
            if(validatePhone($('#' + $scope.model.newPhoneNumId).widget().getValue()) !== '')
            {
                $('#' + $scope.model.newPhoneNumId).widget().option('focused', true);
                return;
            }
            var $step2 = $('#step2');
            if (!iamUtils.unifyValid.FormValid($step2)) {
                iamUtils.unifyValid.focusFirst($step2);
                return;
            }


            $scope.dft.done(function(){
                changePhoneNum();
            }).fail(function() {
                $('#' + $scope.model.newPhoneNumId).widget().option('focused', true);
            });
        };

        $scope.turnToStep1 = function() {
                
            send2CloudBISafe('button', 'click' , 'fPhone_'+ getQueryString('UserType') +'_turnToStep1' , '');
                
            $('#step2').hide();
            $('#step1').show();
            goToStep(1);
            clearInputStep2($scope);
            util.removeErrorInfo('#phoneError');
            $scope.model.newPhoneNum = '';
            $scope.model.lastEmailAddress = $('#'+$scope.model.registerEmailId).widget().getValue();
            $scope.model.sendEmailVCodeFailed = true;
            $scope.model.sendSmsVCodeFailed = true;
            $scope.model.phoneValidator = iamUtils.validator.phone();
            $scope.model.msgCodeValidator = iamUtils.validator.msgCode();
            $scope.model.smsMsgCodeValidator = iamUtils.validator.smsMsgCode();
            $scope.$evalAsync();
        };
        function clearInputStep2($scope) {
            $scope.model.emailVerifyCode = '';
            $scope.model.smsVerifyCode= '';
            $('#smsCodeMsg').hide();
            $('#emailCodeMsg').hide();
        }
        function changePhoneNum() {
            $('#nextBtn').addClass('submitBtnDisable');
            $('#nextBtn').removeClass('submitBtn');
            var userType = getQueryString('UserType');
            var countryCode =  iamUtils.getCodeValue($scope.model.codeJson, $('#codeSelectId').widget().getValue());
            clearInputStep2($scope);
            iamHttpService.post({
                url: '/rest/authui/fphone/changePhoneNum',
                params: {
                    domain: userType === 'p' ? undefined : encodeURIComponent($('#' + $scope.model.enterpriseId).widget().getValue()),
                    email:  $('#' + $scope.model.registerEmailId).widget().getValue(),
                    countryCode: countryCode,
                    phone: $('#' + $scope.model.newPhoneNumId).widget().getValue(),
                    emailVCode: $('#' + $scope.model.emailVerifyCodeId).widget().getValue(),
                    smsVCode: $('#' + $scope.model.smsVerifyCodeId).widget().getValue()
                }
            }).then(function (data) {
                if (data.retcode == 200) {
                    goToStep(3);
                    $scope.model.maskNewPhoneNum = iamUtils.SecurityMasker.maskMobile(countryCode + '-'+ $scope.model.newPhoneNum).replace(/^0*/, '+').replace(/-/, ' ');
                    $('#step2').hide();
                    $('#step3').show();
                    goToHomeLater();
                }
                else {
                    if (data.retcode == 400) {
                        $scope.model.sendSmsVCodeFailed=true;
                        $scope.model.sendEmailVCodeFailed=true;
                        iamUtils.MESSAGE.ERROR(i18n('invalidInput'), '', 'fphonePopupMsg');
                    }
                    else if (data.retcode == 414) {
                        $scope.model.sendSmsVCodeFailed=true;
                        $scope.model.sendEmailVCodeFailed=true;
                        iamUtils.MESSAGE.ERROR(i18n('verifyCode.invalid'), '', 'fphonePopupMsg');
                    }
                    else if (data.retcode == 415)
                    {
                        $scope.model.sendSmsVCodeFailed=true;
                        $scope.model.sendEmailVCodeFailed=true;
                        iamUtils.MESSAGE.ERROR(i18n('verifyCode.emailInvalidAndSMSError'), '', 'fphonePopupMsg');
                    }
                    else if (data.retcode == 416)
                    {
                        $scope.model.sendSmsVCodeFailed=true;
                        $scope.model.sendEmailVCodeFailed=true;
                        iamUtils.MESSAGE.ERROR(i18n('verifyCode.email.invalid'), '', 'fphonePopupMsg');
                    }
                    else if (data.retcode == 417)
                    {
                        $scope.model.sendSmsVCodeFailed=true;
                        $scope.model.sendEmailVCodeFailed=true;
                        iamUtils.MESSAGE.ERROR(i18n('verifyCode.email.error'), '', 'fphonePopupMsg');
                    }
                    else if (data.retcode == 409) {
                        $scope.model.sendSmsVCodeFailed=true;
                        $scope.model.sendEmailVCodeFailed=true;
                        iamUtils.MESSAGE.ERROR(i18n('fphone.phoneRepeat'), '', 'fphonePopupMsg');
                        $scope.model.newPhoneNumFocused = true;
                    }
                    else if (data.retcode == 403) {
                        $scope.model.sendSmsVCodeFailed = true;
                        $scope.model.sendEmailVCodeFailed = true;
                        iamUtils.MESSAGE.ERROR(i18n('selfManage.alertTip'), '', 'fphonePopupMsg');
                        $scope.model.newPhoneNumFocused = true;
                    }
                    else {
                        $scope.model.sendSmsVCodeFailed=true;
                        $scope.model.sendEmailVCodeFailed=true;
                        iamUtils.MESSAGE.ERROR(i18n('systemException'), '', 'fphonePopupMsg');
                    }
                    var $nextBtn = $('#nextBtn');
                    $nextBtn.addClass('submitBtn');
                    $nextBtn.removeClass('submitBtnDisable');
                }
                try {
                    $scope.$apply();
                }
                catch (e) {

                }
            }, function (data) {
                iamUtils.MESSAGE.ERROR(i18n('systemException'), '', 'fphonePopupMsg');
                var $nextBtn = $('#nextBtn');
                $nextBtn.addClass('submitBtn');
                $nextBtn.removeClass('submitBtnDisable');
                try {
                    $scope.$apply();
                }
                catch (e) {

                }
            });
        }

        function goToStep(stepNum) {
            step.goToStep(stepNum);
        }

        function goToHomeLater() {
            var timeInterval = 10;
            var counter = 0;

            function timer() {
                if (counter < timeInterval) {
                    $scope.model.countToHomepage = iamUtils.i18nFormat(i18n('countToHomepage'), (timeInterval - counter));
                    if (counter != 0)
                    {
                        $scope.$apply();
                    }
                    counter++;
                    setTimeout(timer, 1000);
                }
                else {
                    iamUtils.redirect2Login();
                }
            }

            setTimeout(timer, 0);
        }


        function initPage(iamUtils) {
            var uType = iamUtils.getUrlParams().UserType;
            //var uType = getQueryString('UserType');
            //getQueryString 可能取到#后面的部分
            if (uType == null || uType == '') {
                window.location.assign('/authui');
                return;
            }
            $scope.model.enterpriseFocused = true;
            $scope.model.registerEmailFocused = false;
            if (uType == 'p') {
                $('#enterprise').hide();
                $scope.model.enterpriseFocused = false;
                $scope.model.registerEmailFocused = true;
            }
        }

            

        function validatePhone(value, length){
            if(validateBlank(value) !== '')
            {
                return validateBlank(value);
            }

            if(!me.validatePhoneLength(value)){
                return  i18n('validPhone');
            }
            var phoneLen = length ? length: 32;
            var lengthValidator = validateMaxLength(value, phoneLen, i18n('phoneMaxLenTxt'));
            if( lengthValidator !== '')
            {
                return lengthValidator;
            }
            return '';
        }

        function validateBlank(value)
        {
            if (value == undefined || value.length === 0 || value.toString().indexOf(' ') !== -1) {
                return i18n('emptyTxt');
            }
            return '';
        }

        function validateMaxLength(value, maxLen, errorInfo)
        {
            var minLenNum = Number(maxLen);
            if (isNaN(minLenNum))
            {
                minLenNum = 0;
            }

            if(value.length > maxLen)
            {
                return iamUtils.i18nFormat(errorInfo, minLenNum)
            }

            return '';
        }

        function addErrorInfo(errorTxt, txtFielId, errorInfoid)
        {
            util.removeErrorInfo(errorInfoid);
            var imgSrc = require('custom/images/verifycode_valid.png');
            var errorDomFragment = '<img src="' + imgSrc + '"><span>' + errorTxt + '</span>';
            $(errorInfoid).html(errorDomFragment);
            var tempNewPhoneNum = $('#' + txtFielId);
            if(tempNewPhoneNum[0].tagName === 'INPUT') {
                tempNewPhoneNum.addClass('tiny-input-text valid_error_input');
            }
            else{
                tempNewPhoneNum.find('input').addClass('tiny-input-text valid_error_input');
            }
        }

            

        function limitLength(fieldId, value, length)
        {
            if (value.length > length)
            {
                $('#' +fieldId).val(value.substring(0, length));
            }
        }   

        initPage(iamUtils);
    }
    function getQueryString(param) {
        var query = decodeURI(window.location.search.substring(1));
        var queryArr = query.split('&');
        for (var i = 0; i < queryArr.length; i++) {
            var pairs = queryArr[i].split('=');
            if (param === pairs[0]) {
                return pairs[1];
            }
        }
        return null;
    }

    function showOkImg(txtFielId, infoid)
    {
        util.removeErrorInfo(infoid);
        var tempNewPhoneNum = $('#' + txtFielId);
        if(tempNewPhoneNum[0].tagName === 'INPUT') {
            tempNewPhoneNum.removeClass('valid_error_input');
        }
        else{
            tempNewPhoneNum.find('input').removeClass('valid_error_input');
        }
        var imgSrc = require('custom/images/verifycode_success.png');
        var imgDom = '<img src="' + imgSrc + '"/>';
        $(infoid).html(imgDom);
    }
    FPhoneController.prototype.validatePhoneLength = function (value) {
        var pattern = /^[0-9]\d*$/;
        return pattern.test(value);
    }
        
    FPhoneController.prototype.isKeyExisted = function ($scope, iamHttpService, type, countryCode, value, errorTxt, txtFielId, errorInfoid) {
        var userType = getQueryString('UserType');
             
        $scope.dft  = $.Deferred();
        iamHttpService.post({
            url: '/authui/fphone/exists',
            params: {
                domainName: userType === 'p' ? undefined : encodeURIComponent($('#' + $scope.model.enterpriseId).widget().getValue()),
                countryCode: countryCode,
                mobile: value,
                email: $('#' + $scope.model.registerEmailId).widget().getValue()
            }
        }).then(function (data) {
            if(data.count)
            {
                addErrorInfo(errorTxt, txtFielId, errorInfoid);
                $scope.dft.reject();
            }
            else{
                showOkImg(txtFielId, errorInfoid);
                $scope.dft.resolve();
            }

        }, function (data) {
            addErrorInfo(i18n('systemException'), txtFielId, errorInfoid);
            $scope.dft.resolve();
        });
    }
        
    return FPhoneController;
}
);



// WEBPACK FOOTER //
// ./public/base/js/fphone/controllers/fPhoneController.js